import { StateCreator } from 'zustand';

/** A suggestion category id, or one of the non-category suggestions. */
export type NewChatSuggestion = 'plans' | 'upload' | number;

export interface NewChatSlice {
  newChatSuggestion: NewChatSuggestion | null;
  setNewChatSuggestion: (newChatSuggestion: NewChatSuggestion | null) => void;
}

export const createNewChatSlice: StateCreator<NewChatSlice> = (set) => ({
  newChatSuggestion: null,
  setNewChatSuggestion: (newChatSuggestion) => set({ newChatSuggestion }),
});
